import { notify } from "@/lib/notify";

/** Port of clipboard.ts (Vue) — copies and confirms with a toast. */
export async function copyToClipboard(value: string) {
  if (!navigator.clipboard) {
    notify.info("Opération non supportée", {
      description: "Impossible de copier dans le presse-papier depuis cette application.",
      duration: 7000,
    });
    return;
  }

  await navigator.clipboard.writeText(value);
  notify.success("Texte copié dans le presse-papier", { duration: 3000 });
}
